import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Gift, ArrowsClockwise } from "@phosphor-icons/react";

export default function AdminGiftCards() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/gift-cards").then(r => setRows(r.data || [])).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const resend = async (id) => {
    if (!window.confirm("Re-send the gift code email to the recipient?")) return;
    try {
      await api.post(`/admin/gift-cards/${id}/resend`);
      alert("Email re-sent.");
    } catch (e) {
      alert("Re-send failed: " + (e?.response?.data?.detail || ""));
    }
  };

  const fmt = (n) => `$${Number(n || 0).toFixed(2)}`;
  const status = (s) => {
    const map = {
      pending: { l: "Pending payment", c: "text-ms-warn bg-ms-warn/10" },
      active: { l: "Active", c: "text-ms-success bg-ms-success/10" },
      partially_used: { l: "Partially used", c: "text-ms-brass bg-ms-brass/10" },
      redeemed: { l: "Redeemed", c: "text-ms-stone bg-ms-edge" },
      expired: { l: "Expired", c: "text-ms-danger bg-ms-danger/10" },
    };
    const m = map[s] || { l: s, c: "text-ms-stone bg-ms-cream" };
    return <span className={`px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider ${m.c}`}>{m.l}</span>;
  };

  return (
    <div className="p-10 md:p-12" data-testid="admin-gift-cards">
      <p className="label-eyebrow text-ms-stone">Bookings</p>
      <h1 className="serif text-4xl text-ms-earth mt-2 flex items-center gap-3">
        <Gift size={32} weight="duotone" className="text-ms-brass" /> Gift cards
      </h1>
      <p className="mt-2 text-sm text-ms-stone max-w-2xl">
        Every Mystery Served gift certificate purchased via /gift-cards. Codes activate after Stripe payment clears.
      </p>
      <div className="mt-4 flex items-center gap-2">
        <button onClick={load} className="inline-flex items-center gap-2 px-3 py-1.5 text-xs border border-ms-edge rounded-md text-ms-stone hover:bg-ms-cream" data-testid="gc-refresh">
          <ArrowsClockwise size={12} /> Refresh
        </button>
      </div>

      <section className="mt-8 bg-white border border-ms-edge rounded-2xl overflow-hidden">
        {loading ? (
          <p className="p-6 text-sm text-ms-stone">Loading…</p>
        ) : rows.length === 0 ? (
          <p className="p-6 text-sm text-ms-stone">No gift cards yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-ms-cream/40 border-b border-ms-edge">
              <tr>
                <th className="text-left p-4 label-eyebrow text-[10px]">Code</th>
                <th className="text-left p-4 label-eyebrow text-[10px]">From / To</th>
                <th className="text-right p-4 label-eyebrow text-[10px]">Initial</th>
                <th className="text-right p-4 label-eyebrow text-[10px]">Remaining</th>
                <th className="text-left p-4 label-eyebrow text-[10px]">Status</th>
                <th className="text-left p-4 label-eyebrow text-[10px]">Expires</th>
                <th className="p-4"></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(gc => (
                <tr key={gc.id} className="border-b border-ms-edge last:border-0" data-testid={`gc-row-${gc.id}`}>
                  <td className="p-4 font-mono text-xs text-ms-earth">{gc.code}</td>
                  <td className="p-4 text-ms-stone">
                    <p className="text-ms-earth">{gc.sender_name} → {gc.recipient_name}</p>
                    <p className="text-xs">{gc.recipient_email}</p>
                  </td>
                  <td className="p-4 text-right text-ms-earth">{fmt(gc.amount_initial)}</td>
                  <td className="p-4 text-right text-ms-earth">{fmt(gc.amount_remaining)}</td>
                  <td className="p-4">{status(gc.status)}</td>
                  <td className="p-4 text-xs text-ms-stone">{gc.expires_at ? new Date(gc.expires_at).toLocaleDateString() : "—"}</td>
                  <td className="p-4 text-right">
                    {gc.status !== "pending" && (
                      <button onClick={() => resend(gc.id)} className="text-xs label-eyebrow text-ms-brass hover:text-ms-brass-lo" data-testid={`gc-resend-${gc.id}`}>Re-send →</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}
